import { FronteggContext } from '@frontegg/rest-api';
import { axiosIntegrations } from 'src/lib/axios';
import {
  ehrCredentialsLoadingSlice,
  getEhrCredentialsSlice,
  ehrCredentialsSuccessSlice,
  ehrCallbackSuccessSlice,
} from '../slices/ehrcredentials.slice';

export const pushEHRCredentials = (
  clientId,
  clientSecret,
  org_uuid,
  ehr_system
) => {
  return async (dispatch) => {
    const headers = {
      'Content-Type': 'application/json',
      Accept: 'application/json',
      Authorization: `Bearer ${FronteggContext.getAccessToken()}`,
    };
    const result = await axiosIntegrations.post(
      '/ehr_credentials',
      {
        org_uuid: org_uuid,
        ehr_system: ehr_system,
        ehr: ehr_system,
        credentials: {
          client_id: clientId,
          client_secret: clientSecret,
          redirect_uri:
            import.meta.env.VITE_AMBIENT_UI_BASE_URL + '/ehr/callback',
        },
      },
      {
        headers,
      }
    );
    dispatch(ehrCredentialsLoadingSlice(false));
    if (result?.status === 201) {
      dispatch(ehrCredentialsLoadingSlice(true));
      dispatch(ehrCredentialsSuccessSlice(result?.data));
    } else {
      showToastError('Failed to push EHR credentials');
      dispatch(ehrCredentialsLoadingSlice(false));
      dispatch(ehrCredentialsSuccessSlice(null));
    }
  };
};

export const getEHRCallback = (code, ehr_system, org_uuid) => {
  return async (dispatch) => {
    const headers = {
      'Content-Type': 'application/json',
      Accept: 'application/json',
      Authorization: `Bearer ${FronteggContext.getAccessToken()}`,
    };
    const result = await axiosIntegrations.post(
      '/ehr_credentials/callback',
      {
        code: code,
        ehr_system: ehr_system,
        org_uuid: org_uuid,
      },
      {
        headers,
      }
    );
    dispatch(ehrCallbackSuccessSlice(false));
    if (result?.status === 200) {
      showToastSuccess('EHR credentials pushed successfully');
      dispatch(ehrCallbackSuccessSlice(true));
    } else {
      showToastError('Failed to push EHR credentials');
      dispatch(ehrCallbackSuccessSlice(false));
    }
  };
};

export const getEHRCredentials = (ehr_system, org_uuid) => {
  return async (dispatch) => {
    const headers = {
      'Content-Type': 'application/json',
      Accept: 'application/json',
      Authorization: `Bearer ${FronteggContext.getAccessToken()}`,
    };
    const result = await axiosIntegrations.get(
      `/ehr_credentials?org_uuid=${org_uuid}&ehr_system=${ehr_system}`,
      {
        headers,
      }
    );
    if (result?.status === 200) {
      dispatch(getEhrCredentialsSlice(result?.data));
    } else {
      dispatch(getEhrCredentialsSlice(null));
    }
  };
};

export const deleteEHRCallback = (code, ehr_system, org_uuid) => {
  return async (dispatch) => {
    const headers = {
      'Content-Type': 'application/json',
      Accept: 'application/json',
      Authorization: `Bearer ${FronteggContext.getAccessToken()}`,
    };
    const result = await axiosIntegrations.post(
      `/ehr_credentials/delete`,
      {
        org_uuid: org_uuid,
        ehr_system: ehr_system,
      },
      {
        headers,
      }
    );
    if (result?.status === 200) {
      showToastSuccess('EHR credentials deleted successfully');
    } else {
      showToastError('Failed to delete EHR credentials');
    }
  };
};

export const finalizeEHRSession = (sessionId) => {
  return async (dispatch) => {
    const headers = {
      'Content-Type': 'application/json',
      Accept: 'application/json',
    };
    try {
      const result = await axiosIntegrations.post(
        `/ehr/finalize-session`,
        {
          session_id: sessionId,
        },
        { headers }
      );
      if (result?.status === 200) {
        return true;
      } else {
        return false;
      }
    } catch (error) {
      return false;
    }
  };
};
